import script from "./TheNavigationDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheNavigationDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./TheNavigationDrawer.vue?vue&type=style&index=0&id=60e302c2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e302c2"]])